import * as yup from 'yup';
import 'yup-phone';
import { i18n } from '@lt/localization';
import { FormFields } from './types';

export const validationSchema = yup.object({
  [FormFields.Phone]: yup
    .string()
    // в качестве первых двух параметров передаем undefined, чтобы оставить их дефолтными
    // третьим параметром передаем error-message
    .phone(
      undefined,
      undefined,
      i18n.t('checkout.registrationForm.phone.inputError'),
    )
    .required(i18n.t('checkout.registrationForm.phone.required')),
});
